// extracted by mini-css-extract-plugin
export var metadata = "Post-module--metadata--o1FZp";
export var tags = "Post-module--tags--0jB8j";